import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, blueColor} from '../../cmsMainStyle'

const efilingStyle = theme => ({
	headerFont: defaultMainHeaderFont,
	contentFont: defaultContentFont,
	contentHeaderFont: defaultContentHeaderFont,

	fileManager: {
		flexGrow: 1,
	},

	// fileManagerExplorer: {
	// 	overflowY: "auto",
	// 	minWidth: 350,
	// 	maxWidth: 350,
	// 	backgroundColor: whiteColor,
	// 	borderLeft: "1px solid " + grayColor[4],
	// 	padding: "10px 10px",
	// 	borderRadius: 3
	// },

	// fileManagerContent: {
	// 	flexGrow: 1,
	// 	overflowY: "none",
	// 	backgroundColor: whiteColor,
	// 	borderLeft: "1px solid " + grayColor[4],
	// 	borderRight: "1px solid " + grayColor[4],
	// 	borderRadius: 3
	// },

	fileManagerPath: {
		display: "flex",
		alignItems: "center",
		height: 40,
		paddingLeft: theme.spacing(1),
	},

	fileManagerFileList: {
		flexGrow: 1,
		overflowY: "auto",
	},

	fileManagerLeftPaper: {
		height: 'var(--screen-height)',
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		overflowX: "hidden",
		overflowY: "auto",
	},

	fileManagerRightPaper: {
		height: 'var(--screen-height)'
	},

	navBar: {
		display: "flex",
		alignItems: "center",
		height: 50,
		backgroundColor:  "rgba(242, 242, 242, 1)",
		paddingLeft: theme.spacing(2),
	},

	fileNavIcon: {
		'&:hover': {
			color: blueColor[6],
			borderColor: blueColor[6],
            backgroundColor: blueColor[0],
		},
	},

	loadingBox : {
		display: "flex",
		justifyContent: "center"
	},

})


export default efilingStyle